import React from 'react'
import { Button, Icon, Tooltip, Popover } from 'antd'
import { isWindows } from '../../utils'

import ftXLogo from '../../assets/logo/ftx-colorful-logo.png'
import CloudFlyerAPI from '../../api/CloudFlyerAPI'

import './styles.scss'

export default class commonHeader1 extends React.Component {
    constructor() {
        super()

        this.state = {
            visible: false,
            server_connected: false,
        }
    }

    componentDidMount() {
        CloudFlyerAPI.ftx
            .connect()
            .then(() => this.setState({ server_connected: true }))
            .catch(() => this.setState({ server_connected: false }))
    }

    componentWillReceiveProps(nextProps, nextContext) {}

    onVisibleChange = () => this.setState({ visible: !this.state.visible })

    render() {
        const { server_connected, visible } = this.state
        const {} = this.props

        return (
            <Popover
                placement="bottom"
                trigger="click"
                visible={visible}
                onVisibleChange={this.onVisibleChange}
                overlayClassName={'wrap-ftx-download-popup'}
                content={
                    <div>
                        <div className="logo-container">
                            <Tooltip
                                title={
                                    server_connected
                                        ? 'ftX client is connected.'
                                        : 'ftX client is not connected.'
                                }>
                                <img src={ftXLogo} alt="ftx logo" />
                            </Tooltip>
                        </div>
                        <p>
                            Let's download the CloudFlyer ftX client so that you
                            can move your files so much faster to/from your
                            cloud accounts.
                        </p>

                        <p>
                            {!isWindows() && (
                                <span>
                                    <Icon
                                        type="warning"
                                        style={{ color: 'burlywood' }}
                                    />
                                    &nbsp; ftX is only supported on windows
                                    machine.
                                </span>
                            )}
                        </p>

                        <div className="footer">
                            {isWindows() && (
                                <Button
                                    style={{ width: 200 }}
                                    onClick={e => {
                                        e.stopPropagation()
                                        window.location =
                                            'http://ftx.CloudFlyer.com/download/current/CloudFlyerDesktopFtxSetup.msi'
                                    }}
                                    type="primary"
                                    size="large">
                                    Download ftX Client
                                </Button>
                            )}
                            <Button
                                style={{ width: 200 }}
                                onClick={this.onVisibleChange}
                                size="large">
                                Close
                            </Button>
                        </div>
                    </div>
                }>
                <Tooltip
                    title={
                        server_connected
                            ? 'ftX client is connected.'
                            : 'ftX client is not connected.'
                    }>
                    <img
                        alt="ftx logo"
                        src={ftXLogo}
                        className="ftx-logo"
                        style={{
                            filter: server_connected ? 'none' : 'grayscale(1)',
                        }}
                        onClick={this.onVisibleChange}
                    />
                </Tooltip>
            </Popover>
        )
    }
}
